import { render, staticRenderFns } from "./NotificationListView.vue?vue&type=template&id=43ad0add"
import script from "./NotificationListView.vue?vue&type=script&lang=js"
export * from "./NotificationListView.vue?vue&type=script&lang=js"
import style0 from "./NotificationListView.vue?vue&type=style&index=0&id=43ad0add&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports